import htmx from "htmx.org"

import "htmx_helpers/csrf_token"
import "htmx_helpers/forms"
import "htmx_helpers/error_handlers"
import "htmx_helpers/redirect_handler"
import "htmx_helpers/filters"
import "htmx_helpers/reprocessor_events"

window.htmx = htmx

// Uncomment this to enable logging for HTMX
// window.htmx.logAll()
